import { requests } from "../../../../api/agent"

export default {
	create                : (params) => requests.post('/reReferenceUnit/create', params),
	update                : (params) => requests.post('/reReferenceUnit/update', params),
	delete                : (params) => requests.getWithParams('/reReferenceUnit/delete', params),
	restore               : (params) => requests.getWithParams('/reReferenceUnit/restore', params),
	getPaged              : (params) => requests.getWithParams('/reReferenceUnit/getPaged', params),
	getPagedAll           : (params) => requests.getWithParams('/reReferenceUnit/getPagedAll', params),
	getPagedAudit         : (params) => requests.getWithParams('/reReferenceUnit/getPagedAudit', params),
	getReferenceUnits 	  : (params) => requests.getWithParams('/reReferenceUnit/getReferenceUnits', params),
}